import { z } from "zod";
import { SORT_KEYS } from "./sort.js";

export const saleSearchSchema = z.object({
  q: z.string().trim().min(1).max(200).optional(),
  sort: z.enum(SORT_KEYS).default("default"),
  page: z.coerce.number().int().min(1).default(1),
});

export type SaleSearch = z.infer<typeof saleSearchSchema>;

export type SetSaleSearch = (next: Partial<SaleSearch>) => void;
